import { render } from "./Discounts.vue?vue&type=template&id=eda9acf2&scoped=true"
import script from "./Discounts.vue?vue&type=script&lang=js"
export * from "./Discounts.vue?vue&type=script&lang=js"

import "./Discounts.vue?vue&type=style&index=0&id=eda9acf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eda9acf2"]])

export default __exports__